module.exports = __webpack_public_path__ + "assets/app/img/icon-warning-large.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/images/icon-warning-large.png
// module id = Vdzq
// module chunks = 1